// Walkthrough videos on the public sales pages. Paste either a Cloudflare
// Stream video id (32 hex chars — plays in Key's Stream player) or a direct
// https .mp4 link (e.g. the public no-excuses-deliverables R2 bucket).
// Empty string = the page shows the "video coming soon" frame instead.
export const SALES_VIDEOS = {
  /** /start-checkout — the consumer "AI credit assistant" offer. */
  consumer: "37275d774450dad8c32391333f8df93a",
  /** /pricing and noexcusesdisputes.com — credit repair business owners. */
  business: "37275d774450dad8c32391333f8df93a",
} as const;
